import { Alignment, Button, Collapse, FormGroup, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { generateSchema, IFieldProps } from "decorator-form";
import { ISchema } from "decorator-form/dist/generate";
import React from "react";
import Form from "react-jsonschema-form";

import Class from "core/util/Class";
import { registerField } from "../register";

interface ISubFormWidgetProps<T> extends IFieldProps<any> {
	formClass: T;
	schema?: any;
	settings?: ISubFormSettings;
}

interface ISubFormSettings {
	collapsible?: boolean;
}

export default class SubFormWidget<T> extends React.Component<ISubFormWidgetProps<T>, { isOpen: boolean; }> {

	public state = { isOpen: false };

	public static registerForm<T>(FormClass: Class<T>, settings?: ISubFormSettings): string {
		return registerField(
			(props: IFieldProps<T>) => <SubFormWidget {...props} formClass={FormClass} settings={settings} />,
			"object"
		);
	}

	public render() {
		const { schema, uiSchema }: ISchema = generateSchema(this.props.formClass);
		const { isOpen } = this.state;

		const formContent = (
			<Form
				schema={schema}
				uiSchema={uiSchema}
				onChange={(form) => this.props.onChange(form.formData)}
				formData={this.props.formData || {}}
			><div /></Form>
		);

		return (
			<div>
				<Button
					minimal={true}
					alignText={Alignment.LEFT}
					intent={Intent.PRIMARY}
					active={isOpen}
					fill={true}
					onClick={this.toggleOpen}
					rightIcon={isOpen ? IconNames.SMALL_MINUS : IconNames.SMALL_PLUS}
					children={this.props.schema.title || "Untitled"}
				/>
				<Collapse isOpen={isOpen}>
					<FormGroup>
						{formContent}
					</FormGroup>
				</Collapse>
			</div>
		);
	}

	private toggleOpen = () => this.setState({isOpen: !this.state.isOpen});
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/SubFormWidget.tsx